import { now, oneDayInMs, oneMonthInMs } from '../../utils/time.utils';
import { LoanStatementDto } from '../../../models/dtos/loan-statement.dto';
import { MOCK_LOAN_CAR_ID, MOCK_LOAN_HOME_ID } from './loan.dto.mock';

// LoanStatementDto mocks
export const mockLoanStatementDtoHome1: LoanStatementDto = {
  statement_date: new Date(now - oneMonthInMs * 2).toISOString(),
  due_date: new Date(now - oneMonthInMs * 2 + oneDayInMs * 15).toISOString(),
  past_due_balance: '0.00',
  current_balance: '150000.00',
  current_payoff: '152000.00',
  row_id: '1',
};

export const mockLoanStatementDtoHome2: LoanStatementDto = {
  statement_date: new Date(now - oneMonthInMs * 3).toISOString(),
  due_date: new Date(now - oneMonthInMs * 3 + oneDayInMs * 15).toISOString(),
  past_due_balance: '0.00',
  current_balance: '148800.00',
  current_payoff: '150000.00',
  row_id: '2',
};

export const mockLoanStatementDtoCar1: LoanStatementDto = {
  statement_date: new Date(now - oneMonthInMs).toISOString(),
  due_date: new Date(now - oneMonthInMs + oneDayInMs * 15).toISOString(),
  past_due_balance: '0.00',
  current_balance: '25000.00',
  current_payoff: '25200.00',
  row_id: '3',
};

export const mockLoanStatementDtoCar2: LoanStatementDto = {
  statement_date: new Date(now - oneMonthInMs * 2).toISOString(),
  due_date: new Date(now - oneMonthInMs * 2 + oneDayInMs * 15).toISOString(),
  past_due_balance: '0.00',
  current_balance: '25500.00',
  current_payoff: '25700.00',
  row_id: '4',
};

export const mockLoanStatementDtos: Record<string, LoanStatementDto[]> = {
  [MOCK_LOAN_HOME_ID]: [
    mockLoanStatementDtoHome1,
    mockLoanStatementDtoHome2,
  ],
  [MOCK_LOAN_CAR_ID]: [
    mockLoanStatementDtoCar1,
    mockLoanStatementDtoCar2,
  ],
};
